/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Cancel_FailedInputs */

const en_orders_cancel_failed = /** @type {(inputs: Orders_Cancel_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to cancel order.`)
};

const es_orders_cancel_failed = /** @type {(inputs: Orders_Cancel_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cancelar el pedido.`)
};

/**
* | output |
* | --- |
* | "Failed to cancel order." |
*
* @param {Orders_Cancel_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancel_failed = /** @type {((inputs?: Orders_Cancel_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancel_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancel_failed(inputs)
	return es_orders_cancel_failed(inputs)
});